import { platform as PLATFORM } from "GlobalEnum/Platform";

export const NCF_LINK_TEXT = "Click here to find the right car for you";
export const TRENDING_MODELS_COUNT = 5;
export const FIND_CAR_LINK = "/find-car/";
export const AUTO_COMPLETE_SUGGESTION_TYPES = {
  make: 1,
  newModel: 2,
  upcomingModel: 3,
  dualCompare: 4,
  link: 5,
  discontinuedModel: 6,
};
export const AUTO_COMPLETE_RESULT_COUNT = {
  [PLATFORM.MOBILE.id]: 5,
  [PLATFORM.DESKTOP.id]: 10,
};
